var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElRow',{class:[_vm.spacing ? 'el-row--' + _vm.spacing : '', _vm.line && 'el-row--line', _vm.align === 'baseline' && 'el-row--align-baseline'],attrs:{"tag":_vm.tag,"gutter":_vm.gutter,"type":_vm.type,"justify":_vm.justify,"align":_vm.align}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }